import {inject, Injectable} from '@angular/core';

import {ACCESS_TOKEN} from "@numizmat/constants";
import {environment} from "@numizmat/environments";
import {CookieService} from "@numizmat/services/common";

@Injectable({
  providedIn: 'root'
})
export class AccessTokenService {
  private cookieService: CookieService = inject(CookieService);
  private developmentAccessToken: string = 'eyJhbGciOiJIUzUxMiIsInR5cCI6IkpXVCJ9.eyJ1c2VyLWlkIjoiN2M0MTcyYmEtNWQ4Ni00ZTZlLWE1NzEtNDI4NTM2NTBhZjQzIiwibmJmIjoxNzQ2MDY2Mjk4LCJleHAiOjE3NDY2NzEwOTgsImlhdCI6MTc0NjA2NjI5OH0.ns0exaR9dTZs2Yo5nMsXhEDdCRG9t6Y-0yiomL4G6FZyAr-aop9rw0znMU-ymA7edk9D3jAsGqE8S4sXgtEVIA';

  public getAccessToken(): string | null {
    if (environment.production) {
      return this.cookieService.getCookie(ACCESS_TOKEN);
    } else {
      return this.developmentAccessToken;
    }
  }

  public setAccessToken(accessToken: string): void {
    this.cookieService.setCookie(ACCESS_TOKEN, accessToken);
    if (!environment.production) {
      this.developmentAccessToken = accessToken;
    }
  }

  public deleteAccessToken(): void {
    this.cookieService.deleteCookie(ACCESS_TOKEN);
    if (!environment.production) {
      this.developmentAccessToken = '';
    }
  }
}
